exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".blank-card[data-v-6e231b4c]{width:100%;padding:16px;margin:15px auto}.centerPage[data-v-6e231b4c]{position:absolute;padding:50px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}", ""]);
